export const environment = {
  production: true,
  apiUrl: 'https://infractores.electoralcaba.gob.ar/api/v1',
};
